module.exports = __webpack_public_path__ + "static/pic06-3cc4724c3c01886075e87dcc6cff5618.webp";